import React from "react";


const FrontpageNewsBlock = ({ title, subtitle, latest_news_articles }) => {


    if (!latest_news_articles || latest_news_articles.length === 0) {
        return <p className="text-gray-400">No news available.</p>;
    }
        

    return (
        <div className="frontpage-news-block">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-4 col-lg-6">
                        <span className='eyebrow'>Fréttir</span>
                        <h2 className="title">{title}</h2>
                        <a href="/frettir" className='btn-default d-none d-lg-flex'>Allar fréttir</a>
                    </div>
                    <div className="col-xl-6 col-lg-6 offset-xl-2">
                        <div className="news-container">
                            {latest_news_articles.map((article) => (
                                <a
                                    href={article.page_ptr?.url || `/frettir/${article.slug}`}
                                    key={article.id}
                                    className="d-flex news-card justify-content-between align-items-center"
                                >
                                    <h3>{article.title}</h3>
                                    <div className="green-arrow-btn">
                                        <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.66675 11H5.83341H1.66675ZM28.3334 11L18.3334 1L28.3334 11ZM28.3334 11L18.3334 21L28.3334 11ZM28.3334 11H10.8334H28.3334Z" fill="#ffffff" />
                                            <path d="M1.66675 11H5.83341M28.3334 11L18.3334 1M28.3334 11L18.3334 21M28.3334 11H10.8334" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </a>
                            ))}
                        </div>
                        <a href="/frettir" className='btn-default d-flex d-lg-none'>Fréttir</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FrontpageNewsBlock;
